import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
type RouteRecordRaw = typeof RouteRecordRaw
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/homeIIndex.vue')
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/shop/index.vue')
  },
  {
    path: '/classDetail/:id?',
    name: 'classDetail',
    component: () => import('../views/shop/detail.vue')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('../views/join/form.vue')
  },
  {
    path: '/order/confirm',
    name: 'confirm',
    component: () => import('../views/order/confirm.vue')
  },
  {
    path: '/order/result',
    name: 'result',
    component: () => import('../views/order/result.vue')
  },
  {
    path: '/order/list',
    name: 'orderList',
    component: () => import('../views/order/list.vue')
  },
  {
    path: '/order/detail',
    name: 'orderDetail',
    component: () => import('../views/order/detail.vue')
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/my/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/download/android',
    name: 'androidDownload',
    component: () => import('../views/download/androidDownload.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
